import './SimulationBanner.css';
import { t } from '../../copy/strings';
import { useIsSimulated } from '../../state/hooks';

/** "SIMULAÇÃO" em 600 e o resto em 500: a 1ª palavra de `sim.banner` é a parte forte (§6.9). */
export function splitBanner(text: string): [string, string] {
  const i = text.indexOf(' ');
  return i < 0 ? [text, ''] : [text.slice(0, i), text.slice(i)];
}

/**
 * Faixa "SIMULAÇÃO — dados fictícios" (§6.9, M20): em toda tela de simulação (inclusive TV e replay dentro da
 * simulação), nunca com dados reais, sem como fechar. `isSimulated` decide, nunca `feed.connection`. O AppShell a monta
 * em `.top-bars` (DE-05), primeiro elemento do app; a altura entra nas "barras do topo" de layoutMode() (§4.1).
 */
export function SimulationBanner() {
  const sim = useIsSimulated();
  if (!sim) return null;
  const [strong, rest] = splitBanner(t('sim.banner'));
  return (
    <p class="sim-banner" role="note" data-testid="sim-banner">
      <strong class="sim-banner__strong">{strong}</strong>
      <span class="sim-banner__rest">{rest}</span>
    </p>
  );
}
